import { trackSessionStart } from 'frontend/shared/javascripts/modules/convert_session_tracking'

trackSessionStart()
up.on('up:location:changed', () => trackSessionStart())
